<div style="height:100vh !important">
  <img src="../../assets/img/plane404.svg" />

</div>

<div>
  <button [routerLink]="['/']" class="buttonnew" style="position: absolute; z-index: 1000; bottom: 181px; left: 271px; height: 40px; ">Back To Home</button>
</div>
